import { Box, CircularProgress } from '@mui/material'
import { useWorkcentreStatus } from './SwitchWorkCenter.data'
import { WorkCentreSummaryTableData } from 'Features/WorkCentreSummary/WorkCentreSummary.types'
import { useMemo } from 'react'
import { groupBy } from 'lodash'
import { useNavigate, useLocation } from 'react-router-dom'
import { useParamsOutSideRoutes } from 'Common/Hooks/UseParamsOutSideRoutes.hooks'
import GroupedSelect from './GroupedSelect.view'

export const SwitchWorkCenter = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { workcentreId, planId, sourcesiteId } = useParamsOutSideRoutes()

  const { data: workCentreSummary, isLoading: isWorkcenterSummaryLoading } =
    useWorkcentreStatus(planId, Boolean(planId && workcentreId && sourcesiteId))

  const workcenterOptions = useMemo(() => {
    if (!workCentreSummary) {
      return null
    }
    return groupBy(
      workCentreSummary,
      (workcenter: WorkCentreSummaryTableData) => workcenter.sourceSite
    )
  }, [workCentreSummary])

  const handleWorkcenterChange = (newWorkcenterId: string) => {
    const selectedWorkCenter = workCentreSummary.find(
      (workcenter: WorkCentreSummaryTableData) =>
        Number(workcenter.workCentreKey) === Number(newWorkcenterId)
    )

    if (selectedWorkCenter) {
      // Direct navigation - much faster than path manipulation
      const currentPath = location.pathname

      // Check if we're on a specific page (like edit-capacity, alternative-workcentres, etc.)
      const hasSpecificPage =
        currentPath.includes('/edit-capacity') ||
        currentPath.includes('/alternative-workcentres') ||
        currentPath.includes('/edit-production') ||
        currentPath.includes('/edit-plan-volume')

      if (hasSpecificPage) {
        // Preserve the current page when switching workcentres
        const pageMatch = currentPath.match(
          /\/(edit-capacity|alternative-workcentres|edit-production|edit-plan-volume)/
        )
        const currentPage = pageMatch ? `/${pageMatch[1]}` : ''
        navigate(
          `/plan/${planId}/sourcesite/${selectedWorkCenter.siteKey}/workcentre/${newWorkcenterId}${currentPage}`
        )
      } else {
        // Navigate to workcentre dashboard (default)
        navigate(
          `/plan/${planId}/sourcesite/${selectedWorkCenter.siteKey}/workcentre/${newWorkcenterId}`
        )
      }
    }
  }

  if (!(sourcesiteId && workcentreId && planId)) {
    return null
  }
  return (
    <Box>
      <Box display="flex" justifyContent="end">
        <Box marginLeft={2}>
          {isWorkcenterSummaryLoading ? (
            <CircularProgress color="inherit" size={16} />
          ) : (
            workcenterOptions && (
              <GroupedSelect
                menuItems={workcenterOptions}
                value={workcentreId}
                handleWorkcenterChange={handleWorkcenterChange}
              />
            )
          )}
        </Box>
      </Box>
    </Box>
  )
}
